<template>

  <span>
    <strong
      v-if="isPercent"
      :class="classStyle">
      <span v-if="icon">
        <i v-if="score === 1" class="fas fa-thumbs-down" />
        <i v-if="score === 2" class="fas fa-circle" />
        <i v-if="score === 3" class="fas fa-thumbs-up" />
        <span v-if="score === 4">
           <i class="fas fa-thumbs-up" />
          <i class="fas fa-thumbs-up" />
        </span>
      </span>
      {{ value }}%
      </strong>
    <span
      v-if="!isPercent">
      {{ empty }}
      </span>
  </span>

</template>

<script>
export default {
  name: 'PercentEvaluation',
  props: {
    'value': {
      type: Number,
      default: null
    },
    'empty': {
      type: String,
      default: null
    },
    'icon': {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
    }
  },
  computed: {
    classStyle () {
      return {
        'text-secondary': !this.value,
        'text-danger': this.value <= 25,
        'text-warning': this.value <= 50,
        'text-primary': this.value <= 75,
        'text-success': this.value <= 100
      }
    },
    isPercent () {
      return Number.isInteger(this.value)
    },
    score () {
      if (this.value <= 25) {
        return 1
      } else if (this.value <= 50) {
        return 2
      } else if (this.value <= 75) {
        return 3
      } else {
        return 4
      }
    }
  },
  created () {
  },
  methods: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Parts/PercentEvaluation.vue